import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { smsQueryKeys } from "./smsQueryKeys";

export const useQueryStripeProducts = ({ api }: { api: ApiType }) => {
  return useQuery({
    queryKey: smsQueryKeys.getStripeProducts(),
    queryFn: async () => (await api.smsApi.getStripeProducts()).data,
  });
};
